<div class="flex flex-col gap-6 mt-6">

  <!-- Row: Payments Overview + Budget -->
  <div class="grid grid-cols-1 xl:grid-cols-3 gap-8 w-full">
    <!-- Payments Overview (2/3) -->
    <div
      class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl p-6 shadow sm:col-span-2 md:col-span-4 lg:col-span-2">
      <div
        class="flex flex-col items-start justify-between sm:flex-row">
        <div
          class="truncate text-lg font-medium leading-6 tracking-tight">
          {{'Payments' | transloco}}
        </div>
        <div class="mt-3 sm:ml-2 sm:mt-0">
          <mat-button-toggle-group
            value="this-year"
            #taskDistributionWeekSelector="matButtonToggleGroup">
            <mat-button-toggle value="last-year" (click)='setYear("last-year")'>{{'LastYear' | transloco}}</mat-button-toggle>
            <mat-button-toggle value="this-year" (click)='setYear("this-year")'>{{'ThisYear' | transloco}}</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>
      <div class="mt-6 flex flex-auto flex-col">
        <apx-chart
          class="h-80 w-full flex-auto"
          [chart]="chartTaskDistribution?.chart"
          [labels]="chartTaskDistribution?.labels"
          [legend]="chartTaskDistribution?.legend"
          [plotOptions]="
                                            chartTaskDistribution?.plotOptions
                                        "
          [series]="
                                            chartTaskDistribution?.series
                                        "
          [states]="chartTaskDistribution?.states"
          [stroke]="chartTaskDistribution?.stroke"
          [theme]="chartTaskDistribution?.theme"
          [tooltip]="
                                            chartTaskDistribution?.tooltip
                                        "
          [yaxis]="chartTaskDistribution?.yaxis"></apx-chart>
      </div>
      <div
        class="-m-6 mt-4 grid grid-cols-4 divide-x border-t bg-gray-50 dark:bg-transparent">
        <div
          class="flex flex-col items-center justify-center p-6 sm:p-8">
          <div
            class="text-5xl font-semibold leading-none tracking-tighter">
            {{
            countByType('BankTransfer')
            }}
          </div>
          <div
            class="text-secondary mt-1 text-center">
            {{'Bank' | transloco}}
          </div>
        </div>
        <div
          class="flex flex-col items-center justify-center p-6 sm:p-8">
          <div
            class="text-5xl font-semibold leading-none tracking-tighter">
            {{
            countByType('Card')
            }}
          </div>
          <div
            class="text-secondary mt-1 text-center">
            {{'Card' | transloco}}
          </div>
        </div>
        <div
          class="flex flex-col items-center justify-center p-6 sm:p-8">
          <div
            class="text-5xl font-semibold leading-none tracking-tighter">
            {{
            countByType('Cash')
            }}
          </div>
          <div
            class="text-secondary mt-1 text-center">
            {{'Cash' | transloco}}
          </div>
        </div>
        <div
          class="flex flex-col items-center justify-center p-6 sm:p-8">
          <div
            class="text-5xl font-semibold leading-none tracking-tighter">
            {{
            countByType('Funding')
            }}
          </div>
          <div
            class="text-secondary mt-1 text-center">
            {{'Funding' | transloco}}
          </div>
        </div>
      </div>
    </div>

    <!-- Budget (1/3) -->
    <div
      class="col-span-1 bg-card flex flex-auto flex-col rounded-2xl p-6 shadow">
      <div class="flex items-center">
        <div class="flex flex-col">
          <div
            class="mr-4 truncate text-lg font-medium leading-6 tracking-tight">
            {{'PaymentsSummary' | transloco}}
          </div>
        </div>
      </div>
      <div class="my-8 space-y-8">
        <div class="flex flex-col"
          *ngFor="let label of paymentLabels">
          <div class="flex items-center">
            <!-- Icon bubble per label (optional: tweak bg per label if you want) -->
            <div
              class="flex h-14 w-14 items-center justify-center rounded bg-indigo-100 text-indigo-800 dark:bg-indigo-600 dark:text-indigo-50">
              <mat-icon class="text-current"
                [svgIcon]="label === 'Card' ? 'heroicons_outline:credit-card'
                             : label === 'TradeIn' ? 'heroicons_outline:truck'
                             : 'heroicons_outline:banknotes'"></mat-icon>
            </div>

            <div class="ml-4 flex-auto leading-none">
              <div class="text-secondary text-sm font-medium">
                {{ label | transloco }}
              </div>

              <!-- Total amount this year -->
              <div class="mt-2 text-2xl font-medium">
                {{ sumByType(payments, label) | currency:'USD' }}
                <!-- If you use a CHF pipe later, swap currency pipe accordingly -->
              </div>

              <!-- Progress: current vs previous (prev=100 baseline) -->
              <mat-progress-bar
                class="mt-3 rounded-full"
                [mode]="'determinate'"
                [value]="barValue(label)"></mat-progress-bar>
            </div>

            <!-- % change & arrow -->
            <div class="ml-6 mt-auto flex min-w-18 items-end justify-end">
              <div class="text-lg leading-none">
                {{ changePct(label) | number:'1.1-1' }}%
              </div>
              <mat-icon
                class="ml-1 icon-size-4"
                [ngClass]="arrowColorClass(label)"
                [svgIcon]="arrowIcon(label)"></mat-icon>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

</div>
